import { render, staticRenderFns } from "./ProfileAuthentication.vue?vue&type=template&id=4ed22b0c&scoped=true"
import script from "./ProfileAuthentication.vue?vue&type=script&lang=js"
export * from "./ProfileAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed22b0c",
  null
  
)

export default component.exports